
export const DATASOURCE_SCHEMA = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$comment": "Data source string format: Query::Filter1::Filter2::...::Model?",
    "parameterTypes": {
        "uuid": "Single UUID/GUID",
        "uuid[]": "Comma or semicolon separated UUIDs",
        "string": "Single string value",
        "string[]": "Comma or semicolon separated strings",
        "int": "Integer value",
        "bool": "Boolean value"
    },
    "relationTypes": {
        "self": "References the base entity of the query",
        "foreign": "References a different entity type"
    },
    "datasources": [
        {
            "name": "Activity",
            "class": "ActivityDataSource",
            "file": "Misc/ActivityDataSource.cs",
            "description": "Provides access to activity/workflow event data",
            "queries": [
                {
                    "name": "Activity",
                    "description": "Returns all activities"
                }
            ],
            "filters": [
                {
                    "name": "Own",
                    "description": "Filters activities where the current user is the actor"
                },
                {
                    "name": "Participating",
                    "description": "Filters activities where the current user participated"
                },
                {
                    "name": "Affected",
                    "description": "Filters activities where the current user is affected"
                },
                {
                    "name": "AffectedCorrelations",
                    "description": "Filters activities in process instances where user is affected"
                },
                {
                    "name": "ProcessInstances",
                    "description": "Filters activities that are process instances"
                },
                {
                    "name": "NonProcessInstances",
                    "description": "Filters activities that are not process instances"
                },
                {
                    "name": "OfType",
                    "parameters": [
                        {
                            "name": "types",
                            "type": "string[]",
                            "description": "Event type names"
                        }
                    ],
                    "description": "Filters by event type(s)"
                },
                {
                    "name": "WithType",
                    "aliasOf": "OfType"
                },
                {
                    "name": "WithTypes",
                    "aliasOf": "OfType"
                },
                {
                    "name": "WithPerson",
                    "parameters": [
                        {
                            "name": "personId",
                            "type": "uuid",
                            "relation": "foreign",
                            "referencedEntity": "Person"
                        }
                    ],
                    "description": "Filters by person relation"
                },
                {
                    "name": "WithEntity",
                    "parameters": [
                        {
                            "name": "entityType",
                            "type": "string",
                            "description": "Entity type name"
                        },
                        {
                            "name": "entityId",
                            "type": "uuid",
                            "relation": "dynamic",
                            "description": "Entity ID"
                        }
                    ],
                    "description": "Filters by entity relation"
                },
                {
                    "name": "WithCorrelation",
                    "parameters": [
                        {
                            "name": "correlationId",
                            "type": "uuid",
                            "relation": "foreign",
                            "referencedEntity": "ProcessInstance"
                        }
                    ],
                    "description": "Filters by correlation ID"
                },
                {
                    "name": "WithRootProcessInstance",
                    "aliasOf": "WithCorrelation"
                },
                {
                    "name": "WithRelation",
                    "parameters": [
                        {
                            "name": "property",
                            "type": "string",
                            "description": "Relation property name"
                        },
                        {
                            "name": "id",
                            "type": "uuid",
                            "relation": "dynamic"
                        }
                    ],
                    "description": "Filters by relation property"
                }
            ],
            "models": []
        },
        {
            "name": "Agent",
            "class": "AgentDataSource",
            "file": "Cryptography/AgentDataSource.cs",
            "description": "Provides access to cryptographic agent data",
            "queries": [
                {
                    "name": "Agent",
                    "description": "Returns all agents"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "Artifact",
            "class": "ArtifactDataSource",
            "file": "Configuration/ArtifactDataSource.cs",
            "description": "Provides access to configuration artifacts",
            "queries": [
                {
                    "name": "Artifact",
                    "description": "Returns all artifacts"
                }
            ],
            "filters": [
                {
                    "name": "OfType",
                    "parameters": [
                        {
                            "name": "types",
                            "type": "string[]",
                            "description": "Artifact type or subtype names"
                        }
                    ],
                    "description": "Filters by type/subtype"
                }
            ],
            "models": []
        },
        {
            "name": "Attribute",
            "class": "AttributeDataSource",
            "file": "AttributeDataSource.cs",
            "description": "Generic attribute filtering (IsGeneric = true)",
            "queries": [],
            "filters": [
                {
                    "name": "WithAttribute",
                    "parameters": [
                        {
                            "name": "attributeList",
                            "type": "string[]",
                            "description": "Attribute names"
                        }
                    ],
                    "description": "Filters entities with any attribute"
                },
                {
                    "name": "WithAttributeList",
                    "aliasOf": "WithAttribute"
                },
                {
                    "name": "WithoutAttribute",
                    "parameters": [
                        {
                            "name": "attributeList",
                            "type": "string[]",
                            "description": "Attribute names"
                        }
                    ],
                    "description": "Filters entities without attributes"
                },
                {
                    "name": "WithoutAttributeList",
                    "aliasOf": "WithoutAttribute"
                }
            ],
            "models": []
        },
        {
            "name": "Authority",
            "class": "AuthorityDataSource",
            "file": "Cryptography/AuthorityDataSource.cs",
            "description": "Provides access to certificate authority data",
            "queries": [
                {
                    "name": "Authority",
                    "description": "Returns all certificate authorities"
                }
            ],
            "filters": [],
            "models": [
                {
                    "name": "AuthorityDetailModel",
                    "query": "Authority",
                    "description": "Detailed authority model"
                }
            ]
        },
        {
            "name": "Badge",
            "class": "BadgeDataSource",
            "file": "Badge/BadgeDataSource.cs",
            "description": "Provides access to badge data with extensive state filtering",
            "queries": [
                {
                    "name": "Badge",
                    "description": "Returns all badges"
                },
                {
                    "name": "BadgeProductionLog",
                    "description": "Returns badge production log entries"
                }
            ],
            "filters": [
                {
                    "name": "OfBadgeType",
                    "parameters": [
                        {
                            "name": "ids",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "BadgeType"
                        }
                    ],
                    "description": "Filters by badge type IDs"
                },
                {
                    "name": "OfBadgeTemplate",
                    "parameters": [
                        {
                            "name": "ids",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "BadgeTemplate"
                        }
                    ],
                    "description": "Filters by badge template IDs"
                },
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Badge"
                        }
                    ],
                    "description": "Filters by badge IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "WithPerson",
                    "description": "Filters badges assigned to a person"
                },
                {
                    "name": "WithUser",
                    "description": "Filters badges assigned to current user"
                },
                {
                    "name": "WithPool",
                    "description": "Filters badges assigned to a pool"
                },
                {
                    "name": "OfPool",
                    "parameters": [
                        {
                            "name": "poolId",
                            "type": "uuid",
                            "relation": "foreign",
                            "referencedEntity": "Pool"
                        }
                    ],
                    "description": "Filters by pool ID"
                },
                {
                    "name": "WithContractor",
                    "description": "Filters badges assigned to contractor/visitor"
                },
                {
                    "name": "WithVisitor",
                    "description": "Filters badges assigned to visitor"
                },
                {
                    "name": "NotProduced",
                    "description": "Filters unproduced badges"
                },
                {
                    "name": "Produced",
                    "description": "Filters produced badges"
                },
                {
                    "name": "Approved",
                    "description": "Filters approved badges"
                },
                {
                    "name": "NotApproved",
                    "description": "Filters non-approved badges"
                },
                {
                    "name": "Active",
                    "description": "Filters active badges"
                },
                {
                    "name": "NotActive",
                    "description": "Filters inactive badges"
                },
                {
                    "name": "WasActive",
                    "description": "Filters previously active badges"
                },
                {
                    "name": "Ready",
                    "description": "Filters Ready state badges"
                },
                {
                    "name": "NotReady",
                    "description": "Filters non-Ready state badges"
                },
                {
                    "name": "Leased",
                    "description": "Filters leased badges"
                },
                {
                    "name": "NotLeased",
                    "description": "Filters non-leased badges"
                },
                {
                    "name": "Replaced",
                    "description": "Filters replaced badges"
                },
                {
                    "name": "NotReplaced",
                    "description": "Filters non-replaced badges"
                },
                {
                    "name": "Blocked",
                    "description": "Filters blocked badges"
                },
                {
                    "name": "NotBlocked",
                    "description": "Filters unblocked badges"
                },
                {
                    "name": "Returned",
                    "description": "Filters returned badges"
                },
                {
                    "name": "NotReturned",
                    "description": "Filters non-returned badges"
                },
                {
                    "name": "Elapsed",
                    "description": "Filters elapsed badges"
                },
                {
                    "name": "NotElapsed",
                    "description": "Filters non-elapsed badges"
                },
                {
                    "name": "Destroyed",
                    "description": "Filters destroyed badges"
                },
                {
                    "name": "NotDestroyed",
                    "description": "Filters non-destroyed badges"
                },
                {
                    "name": "Instantiated",
                    "description": "Filters instantiated badges"
                },
                {
                    "name": "NotInstantiated",
                    "description": "Filters non-instantiated badges"
                },
                {
                    "name": "WithBlockReason",
                    "parameters": [
                        {
                            "name": "reasons",
                            "type": "string[]",
                            "description": "Block reason values"
                        }
                    ],
                    "description": "Filters by block reason"
                },
                {
                    "name": "WithoutBlockReason",
                    "parameters": [
                        {
                            "name": "reasons",
                            "type": "string[]",
                            "description": "Block reason values"
                        }
                    ],
                    "description": "Excludes block reasons"
                }
            ],
            "models": [
                {
                    "name": "BadgeModel",
                    "query": "Badge",
                    "description": "Standard badge model"
                },
                {
                    "name": "PersonBadgeModel",
                    "query": "Badge",
                    "description": "Badge with person info"
                },
                {
                    "name": "KeyValue",
                    "query": "Badge",
                    "description": "ID and badge number/version"
                }
            ]
        },
        {
            "name": "BadgeEncoding",
            "class": "BadgeEncodingDataSource",
            "file": "Badge/BadgeEncodingDataSource.cs",
            "description": "Provides access to badge encoding artifacts",
            "queries": [
                {
                    "name": "BadgeEncoding",
                    "description": "Returns encoding artifacts"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "BadgeJournal",
            "class": "BadgeLogDataSource",
            "file": "Badge/BadgeLogDataSource.cs",
            "description": "Provides access to badge journal data",
            "queries": [
                {
                    "name": "BadgeJournal",
                    "description": "Returns badge journal entries"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "BadgeTemplate",
            "class": "BadgeTemplateDataSource",
            "file": "Badge/BadgeTemplateDataSource.cs",
            "description": "Provides access to badge template data",
            "queries": [
                {
                    "name": "BadgeTemplate",
                    "description": "Returns all badge templates"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "BadgeTemplate"
                        }
                    ],
                    "description": "Filters by template IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "WithNameList",
                    "parameters": [
                        {
                            "name": "nameList",
                            "type": "string[]",
                            "description": "Template names"
                        }
                    ],
                    "description": "Filters by names"
                },
                {
                    "name": "OfBadgeTypeId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "BadgeType"
                        }
                    ],
                    "description": "Filters by badge type ID"
                },
                {
                    "name": "OfBadgeTypeName",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "string[]",
                            "description": "Badge type names"
                        }
                    ],
                    "description": "Filters by badge type name"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "BadgeTemplate",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "BadgeType",
            "class": "BadgeTypeDataSource",
            "file": "Badge/BadgeTypeDataSource.cs",
            "description": "Provides access to badge type data",
            "queries": [
                {
                    "name": "BadgeType",
                    "description": "Returns all badge types"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "BadgeType"
                        }
                    ],
                    "description": "Filters by type IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "WithNameList",
                    "parameters": [
                        {
                            "name": "nameList",
                            "type": "string[]",
                            "description": "Type names"
                        }
                    ],
                    "description": "Filters by names"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "BadgeType",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "BadgeWorkstation",
            "class": "BadgeWorkstationDataSource",
            "file": "Badge/BadgeWorkstationDataSource.cs",
            "description": "Provides access to badge workstation data",
            "queries": [
                {
                    "name": "BadgeWorkstation",
                    "description": "Returns all badge workstations"
                }
            ],
            "filters": [
                {
                    "name": "WithBadgeType",
                    "parameters": [
                        {
                            "name": "typeList",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "BadgeType"
                        }
                    ],
                    "description": "Filters by badge type"
                },
                {
                    "name": "Connected",
                    "description": "Filters connected workstations"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "BadgeWorkstation",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "Catalog",
            "class": "CatalogDataSource",
            "file": "Misc/CatalogDataSource.cs",
            "description": "Provides access to catalog data",
            "queries": [
                {
                    "name": "Catalog",
                    "description": "Returns all catalogs"
                }
            ],
            "filters": [
                {
                    "name": "WithPerson",
                    "parameters": [
                        {
                            "name": "personId",
                            "type": "uuid",
                            "relation": "foreign",
                            "referencedEntity": "Person"
                        }
                    ],
                    "description": "Filters by person"
                },
                {
                    "name": "WithEntity",
                    "parameters": [
                        {
                            "name": "entityType",
                            "type": "string"
                        },
                        {
                            "name": "entityId",
                            "type": "uuid",
                            "relation": "dynamic"
                        }
                    ],
                    "description": "Filters by entity"
                },
                {
                    "name": "WithSubject",
                    "aliasOf": "WithEntity"
                }
            ],
            "models": []
        },
        {
            "name": "CatalogDocument",
            "class": "CatalogDocumentDataSource",
            "file": "Misc/CatalogDocumentDataSource.cs",
            "description": "Provides access to catalog document data",
            "queries": [
                {
                    "name": "CatalogDocument",
                    "description": "Returns all catalog documents"
                }
            ],
            "filters": [
                {
                    "name": "Latest",
                    "description": "Filters to latest versions"
                },
                {
                    "name": "WithPerson",
                    "parameters": [
                        {
                            "name": "personId",
                            "type": "uuid",
                            "relation": "foreign",
                            "referencedEntity": "Person"
                        }
                    ],
                    "description": "Filters by person"
                },
                {
                    "name": "WithEntity",
                    "parameters": [
                        {
                            "name": "entityType",
                            "type": "string"
                        },
                        {
                            "name": "entityId",
                            "type": "uuid",
                            "relation": "dynamic"
                        }
                    ],
                    "description": "Filters by entity"
                },
                {
                    "name": "WithSubject",
                    "aliasOf": "WithEntity"
                },
                {
                    "name": "WithState",
                    "parameters": [
                        {
                            "name": "state",
                            "type": "string[]",
                            "description": "Document states"
                        }
                    ],
                    "description": "Filters by state"
                }
            ],
            "models": []
        },
        {
            "name": "Certificate",
            "class": "CertificateDataSource",
            "file": "Cryptography/CertificateDataSource.cs",
            "description": "Provides access to certificate data",
            "queries": [
                {
                    "name": "Certificate",
                    "description": "Returns all certificates"
                }
            ],
            "filters": [
                {
                    "name": "WithUsage",
                    "parameters": [
                        {
                            "name": "usage",
                            "type": "string",
                            "description": "Usage name or OID"
                        }
                    ],
                    "description": "Filters by usage"
                },
                {
                    "name": "WithExtension",
                    "parameters": [
                        {
                            "name": "extension",
                            "type": "string",
                            "description": "Extension name or OID"
                        }
                    ],
                    "description": "Filters by extension"
                },
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Certificate"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "WithPerson",
                    "description": "Filters certificates with person"
                },
                {
                    "name": "WithBadge",
                    "description": "Filters certificates with badge"
                },
                {
                    "name": "Requested",
                    "description": "Filters Requested state"
                },
                {
                    "name": "NotRequested",
                    "description": "Filters non-Requested state"
                },
                {
                    "name": "Active",
                    "description": "Filters Issued state"
                },
                {
                    "name": "Issued",
                    "aliasOf": "Active"
                },
                {
                    "name": "NotActive",
                    "description": "Filters non-Issued state"
                },
                {
                    "name": "NotIssued",
                    "aliasOf": "NotActive"
                },
                {
                    "name": "Revoked",
                    "description": "Filters Revoked state"
                },
                {
                    "name": "NotRevoked",
                    "description": "Filters non-Revoked state"
                },
                {
                    "name": "Elapsed",
                    "description": "Filters Elapsed state"
                },
                {
                    "name": "NotElapsed",
                    "description": "Filters non-Elapsed state"
                }
            ],
            "models": []
        },
        {
            "name": "CertifiedApplication",
            "class": "CertifiedApplicationDataSource",
            "file": "Cryptography/CertifiedApplicationDataSource.cs",
            "description": "Provides access to certified application data",
            "queries": [
                {
                    "name": "CertifiedApplication",
                    "description": "Returns all certified applications"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "Company",
            "class": "CompanyDataSource",
            "file": "Identity/CompanyDataSource.cs",
            "description": "Provides access to company data",
            "queries": [
                {
                    "name": "Company",
                    "description": "Returns all companies"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Company"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "Active",
                    "description": "Filters onboarded companies"
                },
                {
                    "name": "Onboarded",
                    "aliasOf": "Active"
                },
                {
                    "name": "Offboarded",
                    "description": "Filters offboarded companies"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "Company",
                    "description": "ID and short name"
                }
            ]
        },
        {
            "name": "Deployment",
            "class": "DeploymentDataSource",
            "file": "Workflow/DeploymentDataSource.cs",
            "description": "Provides access to workflow deployment data",
            "queries": [
                {
                    "name": "Deployment",
                    "description": "Returns all deployments"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "Entrance",
            "class": "EntranceDataSource",
            "file": "Visitor/EntranceDataSource.cs",
            "description": "Provides access to visitor entrance data",
            "queries": [
                {
                    "name": "Entrance",
                    "description": "Returns all entrances"
                },
                {
                    "name": "EntranceDoormen",
                    "description": "Returns entrance doormen"
                }
            ],
            "filters": [
                {
                    "name": "Active",
                    "description": "Filters active entrances"
                },
                {
                    "name": "Inactive",
                    "description": "Filters inactive entrances"
                },
                {
                    "name": "WithUser",
                    "description": "Filters entrances where user is doorman"
                },
                {
                    "name": "WithDoorman",
                    "aliasOf": "WithUser"
                },
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "id",
                            "type": "uuid",
                            "relation": "self",
                            "referencedEntity": "Entrance"
                        }
                    ],
                    "description": "Filters by ID"
                }
            ],
            "models": [
                {
                    "name": "ActiveVisits",
                    "query": "Entrance",
                    "outputType": "Visit",
                    "description": "Active visits at entrance"
                },
                {
                    "name": "AllVisits",
                    "query": "Entrance",
                    "outputType": "Visit",
                    "description": "All visits at entrance"
                },
                {
                    "name": "ActiveVisitors",
                    "query": "Entrance",
                    "outputType": "Visitor",
                    "description": "Active visitors"
                },
                {
                    "name": "AllVisitors",
                    "query": "Entrance",
                    "outputType": "Visitor",
                    "description": "All visitors"
                },
                {
                    "name": "Metric",
                    "query": "Entrance",
                    "description": "Entrance metrics"
                },
                {
                    "name": "KeyValue",
                    "query": "Entrance",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "Entitlement",
            "class": "EntitlementDataSource",
            "file": "Entitlement/EntitlementDataSource.cs",
            "description": "Provides access to entitlement data",
            "queries": [
                {
                    "name": "PersonEntitlement",
                    "alias": "Entitlement",
                    "description": "Person entitlements"
                },
                {
                    "name": "Entitlement",
                    "description": "All entitlements"
                }
            ],
            "filters": [
                {
                    "name": "WithState",
                    "parameters": [
                        {
                            "name": "states",
                            "type": "string[]",
                            "description": "State values"
                        }
                    ],
                    "description": "Filters by state"
                },
                {
                    "name": "WithoutState",
                    "parameters": [
                        {
                            "name": "states",
                            "type": "string[]",
                            "description": "State values"
                        }
                    ],
                    "description": "Excludes states"
                },
                {
                    "name": "WithParent",
                    "parameters": [
                        {
                            "name": "types",
                            "type": "string[]",
                            "description": "Parent types",
                            "optional": true
                        }
                    ],
                    "description": "Filters with parent"
                },
                {
                    "name": "WithoutParent",
                    "description": "Filters without parent"
                },
                {
                    "name": "Requested",
                    "description": "Filters Requested state"
                },
                {
                    "name": "NotRequested",
                    "description": "Filters non-Requested"
                },
                {
                    "name": "Discarded",
                    "description": "Filters Discarded state"
                },
                {
                    "name": "NotDiscarded",
                    "description": "Filters non-Discarded"
                },
                {
                    "name": "Pending",
                    "description": "Filters Pending state"
                },
                {
                    "name": "NotPending",
                    "description": "Filters non-Pending"
                },
                {
                    "name": "Suspended",
                    "description": "Filters Suspended state"
                },
                {
                    "name": "NotSuspended",
                    "description": "Filters non-Suspended"
                },
                {
                    "name": "Active",
                    "description": "Filters Active state"
                },
                {
                    "name": "NotActive",
                    "description": "Filters non-Active"
                },
                {
                    "name": "Paused",
                    "description": "Filters Paused state"
                },
                {
                    "name": "NotPaused",
                    "description": "Filters non-Paused"
                },
                {
                    "name": "Revoked",
                    "description": "Filters Revoked state"
                },
                {
                    "name": "NotRevoked",
                    "description": "Filters non-Revoked"
                },
                {
                    "name": "Elapsed",
                    "description": "Filters Elapsed state"
                },
                {
                    "name": "NotElapsed",
                    "description": "Filters non-Elapsed"
                }
            ],
            "models": []
        },
        {
            "name": "EntitlementAudit",
            "class": "EntitlementLogDataSource",
            "file": "Entitlement/EntitlementLogDataSource.cs",
            "description": "Provides access to entitlement audit data",
            "queries": [
                {
                    "name": "PersonEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Person audit"
                },
                {
                    "name": "GroupEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Group audit"
                },
                {
                    "name": "CompanyEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Company audit"
                },
                {
                    "name": "PoolEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Pool audit"
                },
                {
                    "name": "EntranceEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Entrance audit"
                },
                {
                    "name": "VisitEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Visit audit"
                },
                {
                    "name": "VisitorEntitlementAudit",
                    "alias": "EntitlementAudit",
                    "description": "Visitor audit"
                },
                {
                    "name": "EntitlementJournal",
                    "description": "Entitlement journal"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "EventLog",
            "class": "EventLogDataSource",
            "file": "Monitoring/EventLogDataSource.cs",
            "description": "Provides access to service event logs",
            "queries": [
                {
                    "name": "EventLog",
                    "description": "Returns service logs"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "Group",
            "class": "GroupDataSource",
            "file": "Identity/GroupDataSource.cs",
            "description": "Provides access to organizational group data",
            "queries": [
                {
                    "name": "Group",
                    "description": "All groups"
                },
                {
                    "name": "GroupRoot",
                    "alias": "Group",
                    "description": "Root groups"
                },
                {
                    "name": "GroupNode",
                    "alias": "Group",
                    "description": "Leaf groups"
                }
            ],
            "filters": [
                {
                    "name": "SelectRootGroups",
                    "parameters": [
                        {
                            "name": "type",
                            "type": "string",
                            "description": "Group type"
                        }
                    ],
                    "description": "Filters root by type"
                },
                {
                    "name": "OfType",
                    "parameters": [
                        {
                            "name": "type",
                            "type": "string",
                            "description": "Group type"
                        }
                    ],
                    "description": "Filters by type"
                },
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "ids",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Group"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithParent",
                    "description": "Filters groups with parent"
                },
                {
                    "name": "WithoutId",
                    "parameters": [
                        {
                            "name": "ids",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Group"
                        }
                    ],
                    "description": "Excludes IDs"
                },
                {
                    "name": "WithoutName",
                    "parameters": [
                        {
                            "name": "names",
                            "type": "string[]",
                            "description": "Group names"
                        }
                    ],
                    "description": "Excludes names"
                },
                {
                    "name": "NonRoot",
                    "description": "Filters non-root groups"
                },
                {
                    "name": "Root",
                    "description": "Filters root groups"
                }
            ],
            "models": []
        },
        {
            "name": "GroupMembership",
            "class": "GroupMembershipDataSource",
            "file": "Identity/GroupMembershipDataSource.cs",
            "description": "Provides access to group membership data",
            "queries": [
                {
                    "name": "Membership",
                    "alias": "GroupMembership",
                    "description": "All memberships"
                },
                {
                    "name": "GroupMembership",
                    "description": "Group memberships"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "GroupedDurations",
            "class": "GroupedDurationsDataSource",
            "file": "Monitoring/GroupedDurationsDataSource.cs",
            "description": "Provides grouped duration metrics",
            "queries": [
                {
                    "name": "GroupedDurations",
                    "description": "Grouped duration data"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "Membership",
            "class": "MembershipDataSource",
            "file": "Identity/MembershipDataSource.cs",
            "description": "Provides access to person membership data",
            "queries": [
                {
                    "name": "PersonMembership",
                    "alias": "Membership",
                    "description": "Person memberships"
                }
            ],
            "filters": [
                {
                    "name": "OfType",
                    "parameters": [
                        {
                            "name": "types",
                            "type": "string[]",
                            "description": "Membership types"
                        }
                    ],
                    "description": "Filters by type"
                },
                {
                    "name": "OfRole",
                    "parameters": [
                        {
                            "name": "roles",
                            "type": "string[]",
                            "description": "Role names"
                        }
                    ],
                    "description": "Filters by role"
                },
                {
                    "name": "Pending",
                    "description": "Filters pending memberships"
                },
                {
                    "name": "NotPending",
                    "description": "Filters non-pending"
                },
                {
                    "name": "Elapsed",
                    "description": "Filters elapsed memberships"
                },
                {
                    "name": "NotElapsed",
                    "description": "Filters non-elapsed"
                },
                {
                    "name": "Inherited",
                    "description": "Filters inherited memberships"
                },
                {
                    "name": "NotInherited",
                    "description": "Filters non-inherited"
                }
            ],
            "models": [
                {
                    "name": "PersonMembershipModel",
                    "query": "Membership",
                    "description": "Membership detail model"
                }
            ]
        },
        {
            "name": "Person",
            "class": "PersonDataSource",
            "file": "Identity/PersonDataSource.cs",
            "description": "Provides comprehensive person data access",
            "queries": [
                {
                    "name": "Person",
                    "description": "All persons"
                },
                {
                    "name": "PersonLeader",
                    "alias": "Person",
                    "description": "Persons user leads"
                },
                {
                    "name": "PersonController",
                    "alias": "Person",
                    "description": "Persons who control user"
                },
                {
                    "name": "PersonAdmin",
                    "alias": "Person",
                    "description": "Persons user administers"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Person"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "EmployeeType",
                    "parameters": [
                        {
                            "name": "EmployeeTypes",
                            "type": "string",
                            "description": "Comma-separated types"
                        }
                    ],
                    "description": "Filters by employee type"
                },
                {
                    "name": "Active",
                    "description": "Filters active persons"
                },
                {
                    "name": "NotActive",
                    "description": "Filters inactive persons"
                },
                {
                    "name": "Blocked",
                    "description": "Filters blocked persons"
                },
                {
                    "name": "Unblocked",
                    "description": "Filters unblocked persons"
                },
                {
                    "name": "Suspended",
                    "description": "Filters suspended persons"
                },
                {
                    "name": "Unsuspended",
                    "description": "Filters unsuspended persons"
                },
                {
                    "name": "Onboarded",
                    "description": "Filters onboarded persons"
                },
                {
                    "name": "Offboarded",
                    "description": "Filters offboarded persons"
                },
                {
                    "name": "Archived",
                    "description": "Filters archived persons"
                },
                {
                    "name": "NotArchived",
                    "description": "Filters non-archived persons"
                },
                {
                    "name": "Anonymized",
                    "description": "Filters anonymized persons"
                },
                {
                    "name": "NotAnonymized",
                    "description": "Filters non-anonymized persons"
                },
                {
                    "name": "GroupManaged",
                    "parameters": [
                        {
                            "name": "managerRole",
                            "type": "string",
                            "description": "Manager role"
                        },
                        {
                            "name": "personRole",
                            "type": "string",
                            "description": "Person role",
                            "optional": true
                        }
                    ],
                    "description": "Filters by group management"
                },
                {
                    "name": "InclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string",
                            "description": "Membership type"
                        },
                        {
                            "name": "Nodes",
                            "type": "string",
                            "description": "Comma-separated node names"
                        }
                    ],
                    "description": "Filters by membership hierarchy"
                },
                {
                    "name": "ExclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string",
                            "description": "Membership type"
                        },
                        {
                            "name": "Nodes",
                            "type": "string",
                            "description": "Comma-separated node names"
                        }
                    ],
                    "description": "Filters by exact membership"
                },
                {
                    "name": "ExcludeSelf",
                    "description": "Excludes current user"
                },
                {
                    "name": "Self",
                    "description": "Filters to current user"
                },
                {
                    "name": "WithRole",
                    "parameters": [
                        {
                            "name": "roles",
                            "type": "string[]",
                            "description": "Role names (OR)"
                        }
                    ],
                    "description": "Filters by any role"
                },
                {
                    "name": "WithRoles",
                    "parameters": [
                        {
                            "name": "roles",
                            "type": "string[]",
                            "description": "Role names (AND)"
                        }
                    ],
                    "description": "Filters by all roles"
                },
                {
                    "name": "WithRoleAttributes",
                    "parameters": [
                        {
                            "name": "attributes",
                            "type": "string[]",
                            "description": "Attribute names (AND)"
                        }
                    ],
                    "description": "Filters by role attributes"
                },
                {
                    "name": "WithRoleAttribute",
                    "parameters": [
                        {
                            "name": "attributes",
                            "type": "string[]",
                            "description": "Attribute names (OR)"
                        }
                    ],
                    "description": "Filters by any role attribute"
                }
            ],
            "models": [
                {
                    "name": "DetailModel",
                    "query": "Person",
                    "description": "Detailed model"
                },
                {
                    "name": "ContactModel",
                    "query": "Person",
                    "description": "Contact info"
                },
                {
                    "name": "Summary",
                    "query": "Person",
                    "description": "Summary model"
                },
                {
                    "name": "KeyValue",
                    "query": "Person",
                    "description": "ID and full name"
                },
                {
                    "name": "ModelPersonEntitlements",
                    "query": "Person",
                    "outputType": "Entitlement",
                    "description": "Person entitlements"
                },
                {
                    "name": "ModelPersonEntitlementAudit",
                    "query": "Person",
                    "outputType": "EntitlementAudit",
                    "description": "Entitlement audit"
                },
                {
                    "name": "ModelPersonEntitlementJournal",
                    "query": "Person",
                    "outputType": "EntitlementJournal",
                    "description": "Entitlement journal"
                },
                {
                    "name": "ModelPersonBadgeJournal",
                    "query": "Person",
                    "outputType": "BadgeJournal",
                    "description": "Badge journal"
                },
                {
                    "name": "ModelPersonMemberships",
                    "query": "Person",
                    "outputType": "Membership",
                    "description": "Memberships"
                }
            ]
        },
        {
            "name": "Policy",
            "class": "PolicyDataSource",
            "file": "Entitlement/PolicyDataSource.cs",
            "description": "Provides access to policy data",
            "queries": [
                {
                    "name": "Policy",
                    "description": "All policies"
                },
                {
                    "name": "PolicyRules",
                    "description": "Policy rules"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "Pool",
            "class": "PoolDataSource",
            "file": "Badge/PoolDataSource.cs",
            "description": "Provides access to badge pool data",
            "queries": [
                {
                    "name": "Pool",
                    "description": "All pools"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Pool"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "Pool",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "Process",
            "class": "ProcessDataSource",
            "file": "Workflow/ProcessDataSource.cs",
            "description": "Provides access to workflow process definitions",
            "queries": [
                {
                    "name": "Process",
                    "description": "All processes"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Process"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                }
            ],
            "models": [
                {
                    "name": "ProcessDetailModel",
                    "query": "Process",
                    "description": "Detailed model"
                }
            ]
        },
        {
            "name": "ProcessInstance",
            "class": "ProcessInstanceDataSource",
            "file": "Workflow/ProcessInstanceDataSource.cs",
            "description": "Provides access to workflow process instances",
            "queries": [
                {
                    "name": "ProcessInstance",
                    "description": "All instances"
                },
                {
                    "name": "ProcessInstanceActivity",
                    "alias": "ProcessInstanceActivity",
                    "description": "Instance activities"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "ProcessInstance"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "Running",
                    "description": "Filters running instances"
                },
                {
                    "name": "Failed",
                    "description": "Filters failed instances"
                },
                {
                    "name": "Succeeded",
                    "description": "Filters succeeded instances"
                }
            ],
            "models": [
                {
                    "name": "DetailModel",
                    "query": "ProcessInstance",
                    "description": "Detailed model"
                }
            ]
        },
        {
            "name": "Schedule",
            "class": "ScheduleDataSource",
            "file": "Entitlement/ScheduleDataSource.cs",
            "description": "Provides access to entitlement schedule data",
            "queries": [
                {
                    "name": "Schedule",
                    "description": "All schedules"
                }
            ],
            "filters": [
                {
                    "name": "Deleted",
                    "description": "Filters deleted"
                },
                {
                    "name": "NotDeleted",
                    "description": "Filters non-deleted"
                },
                {
                    "name": "Suspended",
                    "description": "Filters suspended"
                },
                {
                    "name": "NotActive",
                    "aliasOf": "Suspended"
                },
                {
                    "name": "Inactive",
                    "aliasOf": "Suspended"
                },
                {
                    "name": "NotSuspended",
                    "description": "Filters active"
                },
                {
                    "name": "Unsuspended",
                    "aliasOf": "NotSuspended"
                },
                {
                    "name": "Active",
                    "aliasOf": "NotSuspended"
                },
                {
                    "name": "BottomUp",
                    "description": "Filters bottom-up resolution"
                },
                {
                    "name": "TopDown",
                    "description": "Filters top-down resolution"
                },
                {
                    "name": "OfSecurityLevel",
                    "parameters": [
                        {
                            "name": "securityLevelIds",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "SecurityLevel"
                        }
                    ],
                    "description": "Filters by security level"
                },
                {
                    "name": "OfTitle",
                    "parameters": [
                        {
                            "name": "titleIds",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "Title"
                        }
                    ],
                    "description": "Filters by title"
                },
                {
                    "name": "OfGroup",
                    "parameters": [
                        {
                            "name": "groups",
                            "type": "string[]",
                            "description": "Group names"
                        }
                    ],
                    "description": "Filters by group"
                },
                {
                    "name": "WithTag",
                    "parameters": [
                        {
                            "name": "tags",
                            "type": "string[]",
                            "description": "Tag values"
                        }
                    ],
                    "description": "Filters by tags"
                },
                {
                    "name": "WithAttribute",
                    "parameters": [
                        {
                            "name": "attributes",
                            "type": "string[]",
                            "description": "Attribute values"
                        }
                    ],
                    "description": "Filters by attributes"
                },
                {
                    "name": "InclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Nodes",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by membership hierarchy"
                },
                {
                    "name": "ExclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Nodes",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by exact membership"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "Schedule",
                    "description": "ID and name"
                },
                {
                    "name": "KeyValueTime",
                    "query": "Schedule",
                    "description": "ID and name+time"
                },
                {
                    "name": "Aggregates",
                    "query": "Schedule",
                    "description": "Schedule aggregates"
                },
                {
                    "name": "ModelPersonEntitlements",
                    "query": "Schedule",
                    "outputType": "Entitlement",
                    "description": "Person entitlements"
                }
            ]
        },
        {
            "name": "SecurityLevel",
            "class": "SecurityLevelDataSource",
            "file": "Entitlement/SecurityLevelDataSource.cs",
            "description": "Provides access to security level data",
            "queries": [
                {
                    "name": "SecurityLevel",
                    "description": "All security levels"
                }
            ],
            "filters": [
                {
                    "name": "Suspended",
                    "description": "Filters suspended"
                },
                {
                    "name": "NotSuspended",
                    "description": "Filters active"
                },
                {
                    "name": "Unsuspended",
                    "aliasOf": "NotSuspended"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "SecurityLevel",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "Service",
            "class": "ServiceDataSource",
            "file": "Monitoring/ServiceDataSource.cs",
            "description": "Provides discovered service instances",
            "queries": [
                {
                    "name": "Service",
                    "description": "Service instances (empty)"
                }
            ],
            "filters": [],
            "models": []
        },
        {
            "name": "System",
            "class": "SystemDataSource",
            "file": "Entitlement/SystemDataSource.cs",
            "description": "Provides access to entitlement system data",
            "queries": [
                {
                    "name": "System",
                    "description": "All systems"
                }
            ],
            "filters": [],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "System",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "SystemResource",
            "class": "SystemResourceDataSource",
            "file": "Entitlement/SystemResourceDataSource.cs",
            "description": "Provides access to system resource data",
            "queries": [
                {
                    "name": "SystemResource",
                    "description": "All resources"
                }
            ],
            "filters": [
                {
                    "name": "OfSystem",
                    "parameters": [
                        {
                            "name": "systems",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "System"
                        }
                    ],
                    "description": "Filters by system"
                },
                {
                    "name": "OfType",
                    "parameters": [
                        {
                            "name": "types",
                            "type": "string[]",
                            "description": "Resource types"
                        }
                    ],
                    "description": "Filters by type"
                },
                {
                    "name": "OfRegion",
                    "parameters": [
                        {
                            "name": "regions",
                            "type": "string[]",
                            "description": "Region names"
                        }
                    ],
                    "description": "Filters by region"
                },
                {
                    "name": "OfKind",
                    "parameters": [
                        {
                            "name": "kinds",
                            "type": "string[]",
                            "description": "Resource kinds"
                        }
                    ],
                    "description": "Filters by kind"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "SystemResource",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "SystemResourcePlan",
            "class": "SystemResourcePlanDataSource",
            "file": "Entitlement/SystemResourcePlanDataSource.cs",
            "description": "Provides access to system resource plan data",
            "queries": [
                {
                    "name": "SystemResourcePlan",
                    "description": "All plans"
                }
            ],
            "filters": [
                {
                    "name": "OfSystem",
                    "parameters": [
                        {
                            "name": "systems",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "System"
                        }
                    ],
                    "description": "Filters by system"
                }
            ],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "SystemResourcePlan",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "Title",
            "class": "TitleDataSource",
            "file": "Entitlement/TitleDataSource.cs",
            "description": "Provides access to entitlement title data",
            "queries": [
                {
                    "name": "Title",
                    "description": "All titles"
                }
            ],
            "filters": [],
            "models": [
                {
                    "name": "KeyValue",
                    "query": "Title",
                    "description": "ID and name"
                }
            ]
        },
        {
            "name": "UserTask",
            "class": "UserTaskDataSource",
            "file": "Workflow/UserTaskDataSource.cs",
            "description": "Provides workflow user task data",
            "queries": [
                {
                    "name": "UserTask",
                    "description": "User tasks (excluding sub-process)"
                },
                {
                    "name": "UserTaskAny",
                    "alias": "UserTask",
                    "description": "All user tasks"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "UserTask"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "Assigned",
                    "description": "Filters assigned to user (person)"
                },
                {
                    "name": "AssignedPerson",
                    "description": "Filters directly assigned to user"
                },
                {
                    "name": "AssignedRole",
                    "parameters": [
                        {
                            "name": "name",
                            "type": "string",
                            "description": "Role name"
                        }
                    ],
                    "description": "Filters assigned via role"
                },
                {
                    "name": "AssignedTypes",
                    "parameters": [
                        {
                            "name": "types",
                            "type": "string[]",
                            "description": "Assignment types: PERSON, ROLE, group roles"
                        }
                    ],
                    "description": "Filters by assignment types"
                },
                {
                    "name": "Pending",
                    "description": "Filters pending tasks"
                },
                {
                    "name": "Rejected",
                    "description": "Filters rejected tasks"
                },
                {
                    "name": "Completed",
                    "description": "Filters completed tasks"
                },
                {
                    "name": "Done",
                    "description": "Filters done tasks (rejected or completed)"
                },
                {
                    "name": "WithRelation",
                    "parameters": [
                        {
                            "name": "relation",
                            "type": "string",
                            "description": "Relation property name"
                        }
                    ],
                    "description": "Filters with non-null relation"
                },
                {
                    "name": "TaskName",
                    "parameters": [
                        {
                            "name": "taskNames",
                            "type": "string[]",
                            "description": "Task definition names"
                        }
                    ],
                    "description": "Filters by task name"
                },
                {
                    "name": "ProcessKey",
                    "parameters": [
                        {
                            "name": "keyList",
                            "type": "string[]",
                            "description": "Process keys"
                        }
                    ],
                    "description": "Filters by process key"
                },
                {
                    "name": "True",
                    "parameters": [
                        {
                            "name": "propertyPath",
                            "type": "string",
                            "description": "Property path"
                        }
                    ],
                    "description": "Filters where property is true"
                },
                {
                    "name": "False",
                    "parameters": [
                        {
                            "name": "propertyPath",
                            "type": "string",
                            "description": "Property path"
                        }
                    ],
                    "description": "Filters where property is false"
                }
            ],
            "models": [
                {
                    "name": "DetailModel",
                    "query": "UserTask",
                    "description": "Detailed model"
                }
            ]
        },
        {
            "name": "Visit",
            "class": "VisitDataSource",
            "file": "Visitor/VisitDataSource.cs",
            "description": "Provides comprehensive visit data access",
            "queries": [
                {
                    "name": "Visit",
                    "description": "All visits"
                }
            ],
            "filters": [
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Visit"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "Yesterday",
                    "description": "Filters yesterday's visits"
                },
                {
                    "name": "Today",
                    "description": "Filters today's visits"
                },
                {
                    "name": "Tomorrow",
                    "description": "Filters tomorrow's visits"
                },
                {
                    "name": "LastWeek",
                    "description": "Filters last week"
                },
                {
                    "name": "ThisWeek",
                    "description": "Filters this week"
                },
                {
                    "name": "NextWeek",
                    "description": "Filters next week"
                },
                {
                    "name": "LastMonth",
                    "description": "Filters last month"
                },
                {
                    "name": "ThisMonth",
                    "description": "Filters this month"
                },
                {
                    "name": "NextMonth",
                    "description": "Filters next month"
                },
                {
                    "name": "Offset",
                    "parameters": [
                        {
                            "name": "days",
                            "type": "int",
                            "description": "Day offset from today"
                        }
                    ],
                    "description": "Filters by day offset"
                },
                {
                    "name": "OffsetSpan",
                    "parameters": [
                        {
                            "name": "begin",
                            "type": "int",
                            "description": "Start offset"
                        },
                        {
                            "name": "end",
                            "type": "int",
                            "description": "End offset"
                        }
                    ],
                    "description": "Filters by offset span"
                },
                {
                    "name": "Unstarted",
                    "description": "Filters unstarted visits"
                },
                {
                    "name": "Unattended",
                    "description": "Filters unattended visits"
                },
                {
                    "name": "Active",
                    "description": "Filters active visits"
                },
                {
                    "name": "CheckedIn",
                    "description": "Filters checked-in visits"
                },
                {
                    "name": "Unterminated",
                    "description": "Filters unterminated visits"
                },
                {
                    "name": "WithStatus",
                    "parameters": [
                        {
                            "name": "which",
                            "type": "string[]",
                            "description": "Status values"
                        }
                    ],
                    "description": "Filters by status"
                },
                {
                    "name": "WithVisitor",
                    "parameters": [
                        {
                            "name": "which",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "Visitor"
                        }
                    ],
                    "description": "Filters by visitor"
                },
                {
                    "name": "WithReceipient",
                    "parameters": [
                        {
                            "name": "which",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "Person"
                        }
                    ],
                    "description": "Filters by receipient"
                },
                {
                    "name": "WithRequester",
                    "parameters": [
                        {
                            "name": "which",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "Person"
                        }
                    ],
                    "description": "Filters by requester"
                },
                {
                    "name": "WithEntrance",
                    "parameters": [
                        {
                            "name": "which",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "Entrance"
                        }
                    ],
                    "description": "Filters by entrance"
                },
                {
                    "name": "WithBadge",
                    "parameters": [
                        {
                            "name": "which",
                            "type": "uuid[]",
                            "relation": "foreign",
                            "referencedEntity": "Badge"
                        }
                    ],
                    "description": "Filters by badge"
                },
                {
                    "name": "WithUser",
                    "description": "Filters visits related to user"
                },
                {
                    "name": "GroupManaged",
                    "parameters": [
                        {
                            "name": "managerRole",
                            "type": "string"
                        },
                        {
                            "name": "personRole",
                            "type": "string",
                            "optional": true
                        }
                    ],
                    "description": "Filters by group management"
                },
                {
                    "name": "InclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Nodes",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by membership hierarchy"
                },
                {
                    "name": "ExclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Nodes",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by exact membership"
                }
            ],
            "models": [
                {
                    "name": "Details",
                    "query": "Visit",
                    "description": "Visit details"
                },
                {
                    "name": "DetailsWithBadge",
                    "query": "Visit",
                    "description": "Details with badge"
                }
            ]
        },
        {
            "name": "Visitor",
            "class": "VisitorDataSource",
            "file": "Visitor/VisitorDataSource.cs",
            "description": "Provides comprehensive visitor data access",
            "queries": [
                {
                    "name": "Visitor",
                    "description": "All visitors"
                }
            ],
            "filters": [
                {
                    "name": "Archived",
                    "description": "Filters archived"
                },
                {
                    "name": "NotArchived",
                    "description": "Filters non-archived"
                },
                {
                    "name": "Anonymized",
                    "description": "Filters anonymized"
                },
                {
                    "name": "NotAnonymized",
                    "description": "Filters non-anonymized"
                },
                {
                    "name": "Blocked",
                    "description": "Filters blocked"
                },
                {
                    "name": "NotBlocked",
                    "description": "Filters unblocked"
                },
                {
                    "name": "WithId",
                    "parameters": [
                        {
                            "name": "idList",
                            "type": "uuid[]",
                            "relation": "self",
                            "referencedEntity": "Visitor"
                        }
                    ],
                    "description": "Filters by IDs"
                },
                {
                    "name": "WithIdList",
                    "aliasOf": "WithId"
                },
                {
                    "name": "WithCompanyId",
                    "parameters": [
                        {
                            "name": "companyId",
                            "type": "uuid",
                            "relation": "foreign",
                            "referencedEntity": "Company"
                        }
                    ],
                    "description": "Filters by company"
                },
                {
                    "name": "MyReceived",
                    "description": "Filters visitors received by user"
                },
                {
                    "name": "MyRegistered",
                    "description": "Filters visitors registered by user"
                },
                {
                    "name": "MyEntrances",
                    "description": "Filters visitors at user's entrances"
                },
                {
                    "name": "Membership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Node",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by membership"
                },
                {
                    "name": "GroupManaged",
                    "parameters": [
                        {
                            "name": "managerRole",
                            "type": "string"
                        },
                        {
                            "name": "personRole",
                            "type": "string",
                            "optional": true
                        }
                    ],
                    "description": "Filters by group management"
                },
                {
                    "name": "InclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Nodes",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by membership hierarchy"
                },
                {
                    "name": "ExclusiveMembership",
                    "parameters": [
                        {
                            "name": "Type",
                            "type": "string"
                        },
                        {
                            "name": "Nodes",
                            "type": "string"
                        }
                    ],
                    "description": "Filters by exact membership"
                }
            ],
            "models": [
                {
                    "name": "Statistics",
                    "query": "Visitor",
                    "description": "Visitor statistics"
                },
                {
                    "name": "Receipients",
                    "query": "Visitor",
                    "outputType": "Person",
                    "description": "Receipient persons"
                },
                {
                    "name": "PersonReceipients",
                    "query": "Visitor",
                    "outputType": "Person",
                    "description": "Person receipients"
                },
                {
                    "name": "KeyValue",
                    "query": "Visitor",
                    "description": "ID and full name"
                }
            ]
        }
    ]
}
